import script from "./KOPaymentMyTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./KOPaymentMyTicket.vue?vue&type=script&setup=true&lang=js"

import "./KOPaymentMyTicket.vue?vue&type=style&index=0&id=5ef2918a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef2918a"]])

export default __exports__